import Grid from "@mui/material/Grid2";
import { Content, Subtitle, ThinText, Title } from "../../components/texts";
import {
  Button,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
} from "@mui/material";
import { Calendar } from "../../components/calendar";
import { SelectorList } from "../../components/selectorList";
import { ThemeProvider } from "@mui/material/styles";
import { CustomTheme } from "../../components/customTheme";
import React, { useEffect, useRef, useState } from "react";
import InputMask from "react-input-mask";
import { Dayjs } from "dayjs";
import { useParams } from "react-router";
import {
  createAppointment,
  getAvailableHours,
} from "../../services/apiAppointment";
import {
  getEstablishmentById,
  getServicesByEstablishment,
} from "../../services/apiService";
import { Service } from "../../interfaces/service";
import { Appointment } from "../../interfaces/appointment";
import success from "../../assets/sound/beep.mp3";
import useSound from "use-sound";
import { Establishment } from "../../interfaces/establishment";
import BookSuccess from "./success";
import EstablishmentLayout from "./establishmentLayout";
const BookForm: React.FC = () => {
  const [selectedService, setSelectedService] = React.useState<Service>();
  const establishment_id = useParams().establishment_id;
  const [whatsapp, setWhatsapp] = React.useState("");
  const [name, setName] = React.useState("");
  const [isBooked, setIsBooked] = React.useState<boolean>(false);
  const [hourList, setHourList] = React.useState<
    { id: string; name: string }[]
  >([]);

  const [services, setServices] = React.useState<Service[]>([]);
  const [establishment, setEstablishment] = React.useState<Establishment>();

  const [selectedHour, setSelectedHour] = React.useState<string | null>(null);
  const [selectedDate, setSelectedDate] = React.useState<Dayjs | null>(null);

  const calendarContainerRef = useRef<HTMLDivElement>(null);
  const [listHeight, setListHeight] = useState<number | string>("200px"); // Initial height similar to previous maxHeight

  const [successFx] = useSound(success, { volume: 0.4 });

  const handleService = (event: SelectChangeEvent<string>) => {
    const choosenService = services.find(
      (service) => service.service_id === event.target.value
    );
    setSelectedService(choosenService);
  };

  const handleHour = (id: string) => {
    setSelectedHour(id);
  };

  const handleWhatsappChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setWhatsapp(event.target.value);
  };

  const handleDateChange = (date: Dayjs | null) => {
    setSelectedDate(date);
    setSelectedHour(null);
  };

  const getHourList = async () => {
    const availableHours = await getAvailableHours(
      establishment_id!,
      selectedDate!.toISOString().split("T")[0],
      selectedService!.duration
    );

    if (availableHours?.length > 0) {
      setHourList(
        availableHours[0].schedules.map((hour) => ({ id: hour, name: hour }))
      );
    }
  };

  useEffect(() => {
    if (selectedService && selectedDate) {
      getHourList();
    } else {
      setHourList([]);
      setSelectedHour(null);
    }
  }, [selectedService, selectedDate]);

  useEffect(() => {
    getServicesByEstablishment(establishment_id!).then((data) => {
      console.log(data);
      if (data) setServices(data);
    });

    getEstablishmentById(establishment_id!).then((data) => {
      if (data) setEstablishment(data);
    });

    const measureHeight = () => {
      if (calendarContainerRef.current) {
        setListHeight(calendarContainerRef.current.offsetHeight);
      }
    };

    const timerId = setTimeout(measureHeight, 50);

    window.addEventListener("resize", measureHeight);

    return () => {
      clearTimeout(timerId);
      window.removeEventListener("resize", measureHeight);
    };
  }, []);

  const handleSubmit = () => {
    const calculateHourEnd = (
      hourStart: string,
      durationMinutes: number
    ): string => {
      const [hours, minutes] = hourStart.split(":").map(Number);
      const startTime = new Date();
      startTime.setHours(hours, minutes, 0, 0);

      const endTime = new Date(startTime.getTime() + durationMinutes * 60000);

      const endHours = endTime.getHours();
      const endMinutes = endTime.getMinutes();

      const formattedEndHours = endHours < 10 ? `0${endHours}` : `${endHours}`;
      const formattedEndMinutes =
        endMinutes < 10 ? `0${endMinutes}` : `${endMinutes}`;

      return `${formattedEndHours}:${formattedEndMinutes}`;
    };

    if (
      !selectedService ||
      !selectedDate ||
      !selectedHour ||
      whatsapp.replace(/\D/g, "").length !== 11
    ) {
      alert(
        "Por favor, preencha todos os campos obrigatórios (Serviço, Nome, Whatsapp, Dia e Horário)."
      );
      return;
    }

    const hourEnd = calculateHourEnd(selectedHour, selectedService.duration);

    const payload: Appointment = {
      establishment_id: establishment_id!,
      customer_name: name,
      phone_number: parseInt(whatsapp.replace(/\D/g, "")),
      appointment_date: selectedDate!.toISOString().split("T")[0],
      hour_start: selectedHour!,
      hour_end: hourEnd,
      service_id: selectedService!.service_id,
      is_confirmed: false,
    };

    createAppointment(payload)
      .then((response) => {
        successFx();
        setIsBooked(true);
      })
      .catch((error) => {
        console.error("Erro ao criar agendamento:", error);
        alert("Erro ao agendar horário.");
      });
  };

  const theme = CustomTheme(establishment?.accent_color ?? "#061c52");

  return (
    <ThemeProvider theme={theme}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          backgroundColor: theme.palette.background.paper,
          minHeight: "100vh",
        }}
      >
        {isBooked ? (
          <BookSuccess
            selectedService={selectedService}
            selectedDate={selectedDate}
            selectedHour={selectedHour}
          />
        ) : establishment == null ? (
          <Title>Carregando...</Title>
        ) : (
          <EstablishmentLayout establishment={establishment}>
            <Grid size={12}>
              <Subtitle style={{ textAlign: "center" }}>
                Seja bem-vindo! Agende seu horário
              </Subtitle>
            </Grid>
            <Grid size={12}>
              <InputLabel
                id="selectedService-select-label"
                sx={{ fontWeight: "bold" }}
                required
              >
                Escolha o serviço
              </InputLabel>
              <Select
                labelId="selectedService-select-label"
                id="selectedService-select"
                value={selectedService?.establishment_id}
                onChange={handleService}
                fullWidth
              >
                {services.map((service) => (
                  <MenuItem key={service.service_id} value={service.service_id}>
                    {service.name}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid size={6}>
              <InputLabel htmlFor="name-field" sx={{ fontWeight: "bold" }}>
                Nome *
              </InputLabel>
              <TextField
                required
                id="name-field"
                variant="outlined"
                value={name}
                onChange={(e) => setName(e.target.value)}
                fullWidth
              ></TextField>
            </Grid>
            <Grid size={6}>
              <InputLabel htmlFor="phoneNumber" sx={{ fontWeight: "bold" }}>
                Whatsapp *
              </InputLabel>
              <InputMask
                mask="(99) 99999-9999"
                value={whatsapp}
                onChange={handleWhatsappChange}
                disabled={false}
                maskChar=" "
              >
                {(inputProps: any) => (
                  <TextField
                    {...inputProps}
                    required
                    id="phoneNumber"
                    variant="outlined"
                    fullWidth
                  />
                )}
              </InputMask>
            </Grid>
            <Grid size={6}>
              <InputLabel sx={{ fontWeight: "bold" }} required>
                Qual o melhor dia pra você?
              </InputLabel>
              <div ref={calendarContainerRef}>
                <Calendar value={selectedDate} onChange={handleDateChange} />
              </div>
            </Grid>
            <Grid size={6}>
              <InputLabel sx={{ fontWeight: "bold" }}>
                Escolha o melhor horário
              </InputLabel>
              {selectedDate && selectedService && (
                <SelectorList
                  items={hourList}
                  selectedItem={selectedHour}
                  onItemClick={handleHour}
                  height={listHeight}
                />
              )}
              {(!selectedDate || !selectedService) && (
                <Content>Selecione um dia e um serviço primeiro.</Content>
              )}
            </Grid>
            <Grid size={12} sx={{ textAlign: "center" }}>
              <Button
                variant="contained"
                onClick={handleSubmit}
                disabled={!selectedHour}
              >
                {!selectedHour
                  ? "Selecione um horário"
                  : `Agendar às ${selectedHour}`}
              </Button>
            </Grid>
          </EstablishmentLayout>
        )}
      </div>
    </ThemeProvider>
  );
};
export default BookForm;
